<template>
  <div class="tradesman-list">
    <Row>
      <Col :xs="24"
           :sm="24">
      <Form :model="formItem"
            ref="formItem"
            :inline="true"
            action="javascript:void(0)">
        <FormItem>
          <Input v-model="formItem.key"
                 clearable
                 placeholder="输入关键词查找..."></Input>
        </FormItem>
        <FormItem>
          <Button type="primary"
                  @click="renderTable('formItem')">查找</Button>
        </FormItem>
      </Form>
      </Col>
    </Row>
    <Table border
           :columns="list"
           :data="tablelist"
           :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page ref="listPage"
              :total="pages.total"
              :current="pages.page"
              :page-size="pages.size"
              show-elevator
              show-total
              @on-change="changePage()"></Page>
      </div>
    </div>
    <Drawer :title="title"
            v-model="showModalStatus"
            width="1000"
            :mask-closable="false"
            :styles="styles">
      <Form :model="tradesman"
            :label-width="60"
            ref="tradesmanValidate"
            :rules="tradesmanValidate">
        <FormItem label="选择匠人分类"
                  label-position="top">
          <Select v-model="tradesman.cate_id"
                  clearable
                  filterable
                  placeholder="选择匠人分类">
            <Option v-for="item in cateList"
                    :value="item.id"
                    :key="item.id">{{item.name}}</Option>
          </Select>
        </FormItem>
        <FormItem label="选择技艺"
                  label-position="top">
          <Select v-model="tradesman.skill"
                  clearable
                  filterable
                  placeholder="选择技艺">
            <Option v-for="item in skillList"
                    :value="item.id"
                    :key="item.id">{{item.name}}</Option>
          </Select>
        </FormItem>
        <FormItem label="助力技艺"
                  label-position="top"
                  prop="helpless_skill">
          <Input v-model="tradesman.helpless_skill"></Input>
        </FormItem>
        <FormItem label="选择匠人类型"
                  label-position="top">
          <Select v-model="tradesman.type"
                  clearable
                  filterable
                  placeholder="选择匠人类型">
            <Option :value="1"
                    :key="1">企业认证</Option>
            <Option :value="2"
                    :key="2">个人认证</Option>
          </Select>
        </FormItem>
        <FormItem label="匠人等级"
                  label-position="top">
          <Input v-model="tradesman.auth_company"></Input>
        </FormItem>
        <FormItem label="店铺名称"
                  label-position="top"
                  prop="nickname">
          <Input v-model="tradesman.nickname"></Input>
        </FormItem>
        <FormItem label="店铺简介"
                  prop="describe">
          <Input v-model="tradesman.describe"
                 type="textarea"
                 :rows="4"
                 placeholder="店铺简介..."></Input>
        </FormItem>
        <FormItem label="店铺详细介绍"
                  prop="introduce">
          <!--          <editor-bar-->
          <!--            v-model="tradesman.introduce"-->
          <!--            :isClear="isClear"-->
          <!--            ref="editContent"-->
          <!--            @change="change"-->
          <!--          ></editor-bar>-->
          <UEditor v-model="tradesman.introduce"
                   ref="editContent"></UEditor>
        </FormItem>
        <FormItem label="身份证正面照"
                  prop="legal_photo_facade">
          <upload-thumb v-model="tradesman.legal_photo_facade"
                        :ref="thumbRefList[0]"
                        :defaultList="thumblist[0]"
                        :autoCropWidth="118" :autoCropHeight="74"
                        :defaultTip="'图片格式:jpg、jpeg、png、gif,建议图片尺寸:118*74,大小不超过2M'"></upload-thumb>
        </FormItem>
        <FormItem label="身份证反面照"
                  prop="legal_photo_back">
          <upload-thumb v-model="tradesman.legal_photo_back"
                        :ref="thumbRefList[1]"
                        :defaultList="thumblist[1]"
                        :autoCropWidth="118" :autoCropHeight="74"
                        :defaultTip="'图片格式:jpg、jpeg、png、gif,建议图片尺寸:118*74,大小不超过2M'"></upload-thumb>
        </FormItem>
        <FormItem label="匠人头像"
                  prop="thumb">
          <upload-thumb v-model="tradesman.thumb"
                        :ref="thumbRefList[2]"
                        :defaultList="thumblist[2]"
                        :autoCropWidth="100" :autoCropHeight="100"
                        :defaultTip="'图片格式:jpg、jpeg、png、gif,建议图片尺寸:100*100,大小不超过2M'"></upload-thumb>
        </FormItem>
        <FormItem label="形象图片"
                  prop="image">
          <upload-thumb v-model="tradesman.image"
                        :ref="thumbRefList[3]"
                        :defaultList="thumblist[3]"
                        :autoCropWidth="100" :autoCropHeight="100"
                        :defaultTip="'图片格式:jpg、jpeg、png、gif,建议图片尺寸:100*100,大小不超过2M'"></upload-thumb>
        </FormItem>
        <FormItem label="助力图片"
                  prop="works">
          <upload-thumb v-model="tradesman.works"
                        :ref="thumbRefList[4]"
                        :defaultList="thumblist[4]"
                        :autoCropWidth="154" :autoCropHeight="154"
                        :defaultTip="'图片格式:jpg、jpeg、png、gif,建议图片尺寸:154*154,大小不超过2M'"></upload-thumb>
        </FormItem>
        <FormItem label="执照号码"
                  label-position="top">
          <Input v-model="tradesman.company_code"></Input>
        </FormItem>
        <FormItem label="营业执照照片"
                  prop="company_photo">
          <upload-thumb v-model="tradesman.company_photo"
                        :ref="thumbRefList[5]"
                        :defaultList="thumblist[5]"
                        :autoCropWidth="154" :autoCropHeight="154"
                        :defaultTip="'图片格式:jpg、jpeg、png、gif,建议图片尺寸:154*154,大小不超过2M'"></upload-thumb>
        </FormItem>
        <FormItem label="姓名"
                  label-position="top">
          <Input v-model="tradesman.legal_person"></Input>
        </FormItem>
        <FormItem label="电话"
                  label-position="top">
          <Input v-model="tradesman.phone"></Input>
        </FormItem>
        <FormItem label="客服电话"
                  label-position="top">
          <Input v-model="tradesman.servicephone"></Input>
        </FormItem>
        <FormItem label="地址"
                  label-position="top">
          <Input v-model="tradesman.address"></Input>
        </FormItem>
        <FormItem label="专题店铺缩略图"
                  prop="special_thumb">
          <upload-thumb v-model="tradesman.special_thumb"
                        :ref="thumbRefList[6]"
                        :defaultList="thumblist[6]"
                        :autoCropWidth="100" :autoCropHeight="100"
                        :defaultTip="'图片格式:jpg、jpeg、png、gif,建议图片尺寸:100*100,大小不超过2M'"></upload-thumb>
        </FormItem>
        <FormItem label="专题店铺简介"
                  prop="special_describe">
          <Input v-model="tradesman.special_describe"
                 type="textarea"
                 :rows="4"
                 placeholder="专题店铺简介..."></Input>
        </FormItem>
        <FormItem label="是否开发票"
                  label-position="top">
          <RadioGroup v-model="tradesman.is_invoice">
            <Radio :label="0">否</Radio>
            <Radio :label="1">是</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="状态"
                  label-position="top">
          <Tag color="green"
               v-if="tradesman.del_flag == 0">正常</Tag>
          <Tag color="red"
               v-if="tradesman.del_flag == 1">禁用</Tag>
          <!-- <RadioGroup v-model="tradesman.del_flag">
                        <Radio :label="1">正常</Radio>
                        <Radio :label="0">禁用</Radio>
          </RadioGroup>-->
        </FormItem>
        <FormItem label="审核状态"
                  label-position="top">
          <Select v-model="tradesman.status"
                  clearable
                  filterable
                  placeholder="审核状态">
            <Option :value="0"
                    :key="0">待审核</Option>
            <Option :value="1"
                    :key="1">通过审核</Option>
            <Option :value="2"
                    :key="2">未通过审核</Option>
          </Select>
        </FormItem>
        <FormItem label="排序"
                  label-position="top">
          <Input v-model="tradesman.sort"></Input>
        </FormItem>
      </Form>
      <div class="demo-drawer-footer">
        <Button style="margin-right: 8px"
                @click="showModalStatus = false">取消</Button>
        <Button type="primary"
                @click="editgoods('tradesmanValidate')">提交</Button>
      </div>
    </Drawer>
    <!-- 审核的弹出 -->
    <Modal v-model="showEditInfoStatus"
           title="审核"
           @on-ok="updateStatus()"
           :loading="loading">
      <Form :model="review"
            action="javascript:void(0)">
        <FormItem label="修改匠人来源"
                  label-position="top">
          <Select v-model="review.sorce"
                  clearable
                  placeholder="选择匠人来源">
            <Option v-for="item in sorceList"
                    :value="item.id"
                    :key="item.id">{{item.title}}</Option>
          </Select>
        </FormItem>
        <FormItem label="状态">
          <Select v-model="review.status"
                  clearable
                  filterable
                  placeholder="审核状态">
            <Option :value="0">待审核</Option>
            <Option :value="1">通过审核</Option>
            <Option :value="2">未通过审核</Option>
          </Select>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
import UploadThumb from "../common/thumb";
import UEditor from '../common/ueditor';
import uploadthumbTwo from "../common/thumb";
export default {
  name: "tradesman-list",
  data () {
    return {
      //抽屉参数
      value3: false,
      isable: false,
      sorceList: [],
      styles: {
        height: "calc(100% - 55px)",
        overflow: "auto",
        paddingBottom: "53px",
        position: "static"
      },
      review: {
        status: "0",
        sorce: "1"
      },
      tradesman: {
        type: "0",
        is_invoice: "0",
        status: "1",
        auth_status: "0",
        sort: "0"
      },
      isClear: false,
      loading: true,
      dataloading: true,
      thumbRefList: ["zero", "one", "two", "three", "four", "five", "six"],
      thumblist: [[], [], [], [], [], [], []],
      thumblistTwo: [],
      cates: [],
      cateList: [],
      skillList: [],
      trandList: [],
      title: "",
      pages: {
        page: 1,
        size: 10,
        total: 0
      },
      formItem: {
        key: ""
      },
      list: [
        {
          title: "排序",
          key: "sort",
          fixed: "left",
          width: 90
        },
        {
          title: "Id",
          key: "id",
          width: 90
        },
        {
          title: "匠人分类",
          key: "catename",
          width: 150
        },
        {
          title: "店铺名称",
          key: "nickname",
          width: 150
        },
        {
          title: "手机号",
          key: "phone",
          width: 150
        },
        {
          title: "匠人等级",
          key: "auth_company",
          minWidth: 150
        },
        {
          title: "操作",
          key: "action",
          width: 140,
          align: "left",
          fixed: "right",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.detail(params.row.id);
                    }
                  }
                },
                "编辑"
              ),
              h(
                "Button",
                {
                  style: {
                    // marginRight:'8px'
                  },
                  props: {
                    type: "error",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.showreview(params.row.id);
                    }
                  }
                },
                "审核"
              )
            ]);
          }
        }
      ],
      tablelist: [],
      showModalStatus: false,
      showEditInfoStatus: false,
      tradesmanValidate: {}
    };
  },
  created: function () {
    this.getTableList();
    this.getCateList();
    this.getSkillList();
    this.getSorceList();
  },
  components: {
    UploadThumb,
    UEditor,
    uploadthumbTwo
  },

  methods: {
    getTableList: function () {
      this.$api.tradesman
        .reviewlist({ page: this.pages.page, size: this.pages.size, key: this.formItem.key })
        .then(res => {
          this.dataloading = false;
          if (res.code == 200) {
            this.tablelist = res.result.list;
            // for (var i in this.tablelist) {
            //   // console.log(this.tablelist[i]);
            //   this.tablelist[i].phone = this.tablelist[i].data.phone;
            //   this.tablelist[i].auth_company = this.tablelist[
            //     i
            //   ].data.auth_company;
            //   this.tablelist[i].cate = this.tablelist[i].cate.name;
            // }

            this.pages.total = res.result.total;
            this.$Message.success(res.msg);
          }
        });
      return;
    },
    getSorceList () {
      this.$api.tradesmansorce.list({ size: 10 }).then(res => {
        if (res.code == 200) {
          this.sorceList = res.result.list
        }
      })
    },
    getCateList () {
      this.$api.tradesman
        .catelist({ page: 1, size: 1000, status: 1 })
        .then(res => {
          if (res.code == 200) {
            this.cateList = res.result.list;
          }
        });
    },
    getSkillList () {
      this.$api.tradesman
        .skilllist({ page: 1, size: 1000, status: 1 })
        .then(res => {
          if (res.code == 200) {
            this.skillList = res.result.list;
          }
        });
    },
    getTrandList () {
      this.$api.tradesman.list({ page: 1, size: 10000 }).then(res => {
        if (res.code == 200) {
          this.trandList = res.result.list;
        }
      });
    },
    // 详情
    detail (index) {
      this.thumblist = [[], [], [], [], [], [], []];
      this.$refs["tradesmanValidate"].resetFields();
      // this.$refs["editContent"].editor.txt.html("");
      this.$refs["editContent"].message = '';
      this.showModalStatus = !this.showModalStatus;
      this.tradesman.id = index;
      this.$api.tradesman.detail({ id: index }).then(res => {
        this.tradesman = res.result;
        this.tradesman.skill = this.tradesman.data.skill;
        this.tradesman.helpless_skill = this.tradesman.data.helpless_skill;
        this.tradesman.auth_company = this.tradesman.data.auth_company;
        this.tradesman.describe = this.tradesman.data.describe;
        this.tradesman.introduce = this.tradesman.data.introduce;
        this.tradesman.legal_photo_facade = this.tradesman.data.legal_photo_facade;
        this.tradesman.legal_photo_back = this.tradesman.data.legal_photo_back;
        this.tradesman.image = this.tradesman.data.image;
        this.tradesman.works = this.tradesman.data.works;
        this.tradesman.company_code = this.tradesman.data.company_code;
        this.tradesman.company_photo = this.tradesman.data.company_photo;
        this.tradesman.legal_person = this.tradesman.data.legal_person;
        this.tradesman.phone = this.tradesman.data.phone;
        this.tradesman.servicephone = this.tradesman.data.service_phone;
        this.tradesman.address = this.tradesman.data.address;
        this.tradesman.special_thumb = this.tradesman.data.special_thumb;
        this.tradesman.special_describe = this.tradesman.data.special_describe;
        this.tradesman.legal_person = this.tradesman.data.legal_person;
        this.pushThumbData([
          this.tradesman.data.legal_photo_facade,
          this.tradesman.data.legal_photo_back,
          this.tradesman.thumb,
          this.tradesman.data.image,
          this.tradesman.data.works,
          this.tradesman.data.company_photo,
          this.tradesman.data.special_thumb
        ]);
        console.log(this.pushThumbData);
        // this.$refs["editContent"].editor.txt.html(this.tradesman.introduce);
        this.$refs["editContent"].message = this.tradesman.introduce;
      });
    },
    pushThumbData (list) {
      for (var s = 0; s < list.length; s++) {
        if (list[s] != null && list[s] != "") {
          this.thumblist[s].push({
            name: list[s],
            url: list[s],
            status: "finished"
          });
        }
      }
    },
    // 修改
    editgoods (name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          if (this.$refs[this.thumbRefList[0]].uploadList.length > 0) {
            this.tradesman.legal_photo_facade = this.$refs[
              this.thumbRefList[0]
            ].uploadList[0].url;
          }
          if (this.$refs[this.thumbRefList[1]].uploadList.length > 0) {
            this.tradesman.legal_photo_back = this.$refs[
              this.thumbRefList[1]
            ].uploadList[0].url;
          }
          if (this.$refs[this.thumbRefList[2]].uploadList.length > 0) {
            this.tradesman.thumb = this.$refs[
              this.thumbRefList[2]
            ].uploadList[0].url;
          }
          if (this.$refs[this.thumbRefList[3]].uploadList.length > 0) {
            this.tradesman.image = this.$refs[
              this.thumbRefList[3]
            ].uploadList[0].url;
          }
          if (this.$refs[this.thumbRefList[4]].uploadList.length > 0) {
            this.tradesman.works = this.$refs[
              this.thumbRefList[4]
            ].uploadList[0].url;
          }
          if (this.$refs[this.thumbRefList[5]].uploadList.length > 0) {
            this.tradesman.company_photo = this.$refs[
              this.thumbRefList[5]
            ].uploadList[0].url;
          }
          if (this.$refs[this.thumbRefList[6]].uploadList.length > 0) {
            this.tradesman.special_thumb = this.$refs[
              this.thumbRefList[6]
            ].uploadList[0].url;
          }
          this.tradesman.introduce = this.$refs["editContent"].message;
          this.$api.tradesman.edit(this.tradesman).then(res => {
            if (res.code == 200) {
              this.getTableList();
            }
            this.loading = false;
            this.$nextTick(() => {
              this.loading = true;
            });
            this.showModalStatus = !this.showModalStatus;
          });
        } else {
          this.$Message.error("请检查输入的信息是否正确！");
          this.loading = false;
          this.$nextTick(() => {
            this.loading = true;
          });
        }
      });
    },
    // 审核
    showreview: function (id) {
      // 弹出确认框
      this.id = id;
      this.showEditInfoStatus = !this.showEditInfoStatus;
    },
    // 审核
    updateStatus: function (name) {
      this.$api.tradesman
        .review({ id: this.id, status: this.review.status, sorce: this.review.sorce })
        .then(res => {
          if (res.code == 200) {
            this.$Message.success(res.msg);
            this.showEditInfoStatus = !this.showEditInfoStatus;
            this.getTableList();
          }
          this.loading = false;
          this.$nextTick(() => {
            this.loading = true;
          });
          this.showCreateStatus = !this.showCreateStatus;
        });
    },
    change () { },
    // 翻页
    changePage () {
      this.pages.page = this.$refs["listPage"].currentPage;
      this.renderTable(1);
    },
    // 筛选
    renderTable: function (name) {
      if (name != 1) {
        this.pages.page = 1;
      }
      this.getTableList()
      return;
    }
  }
};
</script>

<style>
.demo-drawer-footer {
  width: 100%;
  height: 50px;
  position: absolute;
  bottom: 0;
  left: 0;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  background: #fff;
}
</style>
